import React, { useEffect, useState } from 'react';
import styles from './TrainingSelector.module.css';
import { addTrainingRedux } from '../../store/slices/menuSlice';
import { useDispatch } from 'react-redux';
import LoaderPage from '../LoaderPage/LoaderPage';
import { getDocumentsByField } from '../../firebase';

const trainings = [
  {
    id: 1,
    title: 'Тренування день 1',
    description: 'Тут можна описати відео або ще щось.',
    url: 'https://www.w3schools.com/html/mov_bbb.mp4',
  },
  {
    id: 2,
    title: 'Тренування день 2',
    description: 'Тут можна описати відео або ще щось.',
    url: 'https://www.w3schools.com/html/movie.mp4',
  },
  {
    id: 3,
    title: 'Тренування день 3',
    description: 'Тут можна описати відео або ще щось.',
    url: 'https://www.w3schools.com/html/mov_bbb.mp4',
  },
];

export default function TrainingSelector({ trainingObjectProps }) {
  const dispatch = useDispatch();

  const [loaderPage, setLoaderPage] = useState(false);
  const [open, setOpen] = useState(false);
  const [videosTrainings, setVideosTrainings] = useState([]);
  const [selected, setSelected] = useState(trainingObjectProps ? trainingObjectProps : null);

  useEffect(() => {
    setLoaderPage(true);
    const fetchData = async () => {
      const videos = await getDocumentsByField('files', 'fileType', 'video');
      setVideosTrainings(videos);
      setLoaderPage(false);
    };
    fetchData();
  }, []);

  //Додає посилання на відео
  const addTraining = (trainingObject) => {
    dispatch(addTrainingRedux(trainingObject));
  };

  const handleSelect = (item) => {
    addTraining(item);
    setSelected(item);
    setOpen(false);
  };

  const handleRemove = () => {
    addTraining(null);
    setSelected(null);
  };

  return (
    <div className={styles.wrapper}>
      <button className={styles.button} onClick={() => setOpen(!open)}>
        {selected ? selected.title : 'Вибрати тренування'}
      </button>

      <div className={`${styles.dropdown} ${open ? styles.open : styles.closed}`}>
        {videosTrainings.length ? (
          videosTrainings.map((item) => (
            <div
              key={item.id}
              className={`${styles.item} ${selected?.id === item.id ? styles.active : ''}`}
              onClick={() => handleSelect(item)}>
              <strong>{item.title}</strong>
              <p className={styles.description}>{item.description}</p>
            </div>
          ))
        ) : (
          <div className={styles.item}>Відео не знайдено!</div>
        )}
      </div>

      {selected && (
        <div className={styles.selectedBox}>
          <video src={selected.url} controls width="100%" height="150" className={styles.video} />

          <button className={styles.removeBtn} onClick={handleRemove}>
            Видалити вибране відео
          </button>
        </div>
      )}
      {loaderPage ? <LoaderPage /> : ''}
    </div>
  );
}
